import { combineReducers } from 'redux';
import orgImport from '../OrgImport/reducers/';
export default combineReducers({
  orgImport,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/CompanyAdmin/reducers/index.js
 **/